enum GlobalTypes {
    ADD_ERROR = 'ADD_ERROR',
    ADD_SUCCESS = 'ADD_SUCCESS',
    ADD_SOFTPHONE_ERROR = 'ADD_SOFTPHONE_ERROR',
    CLEAR_SOFTPHONE_ERROR = 'CLEAR_SOFTPHONE_ERROR',
    CLEAR_ERROR = 'CLEAR_ERROR',
    CLEAR_SUCCESS = 'CLEAR_SUCCESS',
    SET_CHANGING_STATE = 'SET_CHANGING_STATE',
    INTERNET_CONNECTION = 'INTERNET_CONNECTION',
    NUMBER_DIALLING = 'NUMBER_DIALLING',
    DO_REDIRECT = 'DO_REDIRECT',
    CLEAR_REDIRECT = 'CLEAR_REDIRECT',
    SHOW_NOTIFICATION = 'SHOW_NOTIFICATION',
    SET_SA_IS_ALREADY_OPEN= 'SET_SA_IS_ALREADY_OPEN',
}

export default GlobalTypes;